<template>
  <div class="footer" v-html="webInfoObj.strFootMessage"></div>
  <!-- <div class="footer">
    <p>版权所有：中国人民政治协商会议安徽省委员会</p>
    <p>皖ICP备05003837号-1 皖公网安备34011102000447号</p>
  </div> -->
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => [],
    },
  },
  created() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.footer {
  box-sizing: border-box;
  padding: 40px 0;
  text-align: center;
  background-color: #CF0016;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  line-height: 2;
  p {
    margin: 0;
  }
}
</style>